import { service } from '../axios';
export function submitInspectionSafeCheck(data) {
    return service({
        url: '/safety/inspection/submit',
        method: 'post',
        data
    });
}
//根据planid返回检查内容
export function getInspectionStandards(planId, labId) {
    return service({
        url: '/safety/inspection/standards',
        method: 'get',
        params: { planId, labId }
    });
}
export function submitHazardRectifySafeCheck(data) {
    return service({
        url: '/safety/inspection/rectify',
        method: 'post',
        data,
    });
}
export function reviewHazardSafeCheck(data) {
    return service({
        url: '/safety/inspection/review',
        method: 'post',
        data,
    });
}
/*根据 recordId 获取该计划的安全检查项*/
export function getInspectionRecordItems(recordId) {
    return service({
        url: '/safety/inspection/getRecordItems',
        method: 'get',
        params: { recordId }
    });
}
// 保存实验室范围（POST）
export function saveInspectionPlanScope(data) {
    return service({
        url: '/safety/inspectionPlan/savePlanScope',
        method: 'post',
        data,
    });
}
// 获取实验室范围回显（GET）
export function getInspectionPlanScope(planId) {
    return service({
        url: '/safety/inspectionPlan/getPlanScope',
        method: 'get',
        params: { planId },
    });
}
//检查人员
export function saveInspectionPlanUsers(data) {
    return service({
        url: '/safety/inspectionPlan/savePlanUsers',
        method: 'post',
        data,
    });
}
//保存检查计划周期
export function saveInspectionPlanCycle(data) {
    return service({
        url: '/safety/inspectionPlan/saveCycle',
        method: 'post',
        data
    });
}
// 获取检查人员范围回显（GET）
export function getInspectionPlanUsers(planId) {
    return service({
        url: '/safety/inspectionPlan/getPlanUsers',
        method: 'get',
        params: { planId },
    });
}
/* 获取检查实验室分页列表*/
export function getInspectionLabPage(query) {
    return service({
        url: '/safety/inspectionPlan/getInspectionLabPage',
        method: 'get',
        params: query,
    });
}
export function loadPlanSafetyCheckItems(planId) {
    return service({
        url: '/safety/inspectionPlan/listByPlanId',
        method: 'get',
        params: { planId }
    });
}
export function savePlanSafetyCheckItems(data) {
    return service({
        url: '/safety/inspectionPlan/savePlanSafetyCheckItems',
        method: 'post',
        data,
    });
}
// 安全检查台账分页查询
export function loadSafetyLedgerPage(data) {
    return service({
        url: '/safety/ledger/page',
        method: 'post',
        data
    });
}
export function loadLabHazardReport() {
    return service({
        url: '/safety/hazard/labReport',
        method: 'get'
    });
}
export function hazardStatusStat() {
    return service({
        url: '/safety/hazard/hazardStatusStat',
        method: 'get'
    });
}
//开始执行
export function setPlanExec(planId) {
    return service({
        url: '/safety/inspectionPlan/setPlanExec',
        method: 'post',
        params: { planId }
    });
}
export function setPlanEnd(planId) {
    return service({
        url: '/safety/inspectionPlan/setPlanEnd',
        method: 'post',
        params: { planId }
    });
}
export function getHazardSummaryCount(params) {
    return service({
        url: '/safety/ledger/getHazardSummaryCount',
        method: 'get',
        params
    });
}
export function checkCanCheckPlans(labId) {
    return service({
        url: '/safety/inspectionPlan/checkCanCheckPlans',
        method: 'post',
        params: { labId }
    });
}
export function getLabRiskList(params) {
    return service({
        url: '/safety/ledger/getLabRiskList',
        method: 'get',
        params
    });
}
export function selectHazardSummaryPage(params) {
    return service({
        url: '/safety/ledger/selectHazardSummaryPage',
        method: 'get',
        params
    });
}
